import { render, staticRenderFns } from "./BuyerBindingCheck.vue?vue&type=template&id=222d3db7&"
import script from "./BuyerBindingCheck.vue?vue&type=script&lang=js&"
export * from "./BuyerBindingCheck.vue?vue&type=script&lang=js&"
import style0 from "./BuyerBindingCheck.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports